import { openDB } from "idb";

const dbName = "happyPurim";
const storeName = "auth";

export const getDB = async () => {
  return openDB(dbName, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName);
      }
    },
  });
};

export const setDBToken = async (token) => {
  const db = await getDB();
  await db.put(storeName, token, "token");
};

export const getDBToken = async () => {
  const db = await getDB();
  return await db.get(storeName, "token");
};
